const descriptions = {
  title: {
    id: 'course-authoring.textbooks.empty-placeholder.title',
    defaultMessage: 'You haven\'t added any textbooks to this course yet.',
    description: 'Message displayed when no textbooks are added to the course',
  },
  button: {
    id: 'course-authoring.textbooks.empty-placeholder.button.new-textbook',
    defaultMessage: 'Add your first textbook',
    description: 'Text for the button to add the first textbook to the course',
  },
};

export default descriptions;
